<template>
    <div>
        <v-menu
            v-if="session.state == 'Established'"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            slide-x
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="teal"
                dark
                v-bind="attrs"
                v-on="on"
                fab
                small
                >
                <v-icon>mdi-phone-forward</v-icon>
                </v-btn>
            </template>
            <v-card height='500' width='350'>
              <v-tabs centered fixed-tabs>
                <v-tabs-slider color='primary'></v-tabs-slider>
                <v-tab>Favorites</v-tab>
                <v-tab-item key="Favorites">
                  <v-simple-table
                  fixed-header
                  height="315px"
                  >
                  <template v-slot:default>
                      <thead>
                      <tr>
                          <th></th>
                          <th class="text-left">
                          Name
                          </th>
                          <th class="text-left">
                          Line
                          </th>
                          <th class="text-left">
                          </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="lk in lineKeys"
                          :key="lk.line_key_id"
                      >
                          <td>
                            <v-icon small v-if='checkBLF(lk) == "terminated"' color='green'>mdi-circle</v-icon>
                            <v-icon small v-else-if='checkBLF(lk) == "confirmed"' color='red'>mdi-circle</v-icon>
                            <v-icon small v-else-if='!checkBLF(lk)' color='gray'>mdi-circle</v-icon>
                            <v-icon small v-else color='orange'>mdi-circle</v-icon>
                          </td>
                          <td v-if='lk.line_label'>
                            {{ lk.line_label }}</td>
                          <td v-if='!lk.line_label'>{{lk.label}}</td>
                          <td>{{ lk.number }}</td>
                          <td><v-btn fab elevation="0" color="blue" small icon @click='$sip.transfer(lk.number)'>
                              <v-icon >mdi-phone-forward</v-icon>
                          </v-btn></td>
                      </tr>
                      </tbody>
                  </template>

                  </v-simple-table>
                </v-tab-item>
                <v-tab>Directory</v-tab>
                <v-tab-item key='Directory'>
                  <v-simple-table
                  fixed-header
                  height="315px"
                  >
                  <template v-slot:default>
                      <thead>
                      <tr>
                          <th class="text-left">
                          Name
                          </th>
                          <th class="text-left">
                          Line
                          </th>
                          <th class="text-left">
                          </th>
                      </tr>
                      </thead>
                      <tbody v-for="group in groups" :key='group'>
                        <tr class="groupHeader">
                          <td>
                            <h6 class='pt-2' v-if='group'>{{group}}</h6>
                            <h6 class='pt-2' v-else>Unspecified</h6>
                          </td>
                          <td></td><td></td>
                        </tr>
                        <tr
                            v-for="contact in directory.data"
                            :key="contact.extension"
                        >
                            <td v-if='contact.directory_group==group'>{{ contact.name }} <span v-if='!contact.name'>Unnamed</span></td>
                            <td v-if='contact.directory_group==group'>{{ contact.extension }}</td>
                            <td v-if='contact.directory_group==group'><v-btn fab elevation="0" color="blue" small icon @click='$sip.transfer(contact.extension)'>
                                <v-icon>mdi-phone-forward</v-icon>
                            </v-btn></td>
                        </tr>
                      </tbody>
                  </template>

                  </v-simple-table>
                </v-tab-item>
              </v-tabs>
              <v-divider></v-divider>
              <v-card-subtitle class="my-0 py-0">
                  <v-text-field 
                      v-model="transferNum"
                      outlined
                      dense
                      label="Transfer Number"
                  >
                  <template v-slot:append-outer>
                      <v-btn fab elevation="0" color="blue" small icon @click='$sip.transfer(transferNum); transferNum=null'>
                      <v-icon>mdi-phone-forward</v-icon>
                      </v-btn>
                  </template>
                  </v-text-field>
                </v-card-subtitle>
                <v-card-actions class="pt-0 mt-0">
                  <v-spacer></v-spacer>
                  <v-btn small text @click="menu = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script >
import { mapState } from "vuex";
import { Invitation } from 'sip.js';
import MediaInputSelector from '../components/media-input-selector.vue';
import Common from '../mixins/common.vue';

export default {
  mixins: [Common],
  data: () =>({
    menu: false,
    transferNum: null,
    contact: { name: {}, displayName: null, nickname: null, phonenumbers: {} },
    contacts: {},
    directory: {},
    groups: [],
  }),
  mounted() { this.attachMedia() },
  updated() { this.attachMedia() },
  computed: {
    ...mapState(["lineKeys", "device", "devices"]),
    session: {
      get() { return this.$store.getters['sip/session'] },
    },
    lineBLF: {
      get() {
        return this.$store.state.lineBLF;
      },
    },
    numberCalling: {
      // This will show the number on the dialpad, but will not always match to the session
      // TODO: get this from the session instead.
      //
      // (will matter more when there are multiple sessions)
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    isDev: {
      get() { return process.env.NODE_ENV!=='production' }
    },
  },
  methods: {
    updateDirectory: function() {
      this.$http
        .get(global.apiurl + "/directory&token=" + this.click2call)
        .then( response => {
          this.directory = response.body;

          for (var i = 0; i < this.directory.data.length; i++) {
            var c = this.directory.data[i];
            if (c.directory_group == null)
            {
              //c.directory_group = 'Unset';
            }

            if (!this.groups.includes(c.directory_group))
            {
              this.groups.push(c.directory_group);
            }
          }
          this.groups.sort();
        });
    },
    checkBLF: function(lineKey) {
      let lkBLF = this.lineBLF.find(e => e.number == lineKey.number);
      if (!lkBLF) return false;
      return lkBLF.blfState;
    },
    logLineKeys(lk) {
      console.log(this.lineKeys)
      console.log('lineKeyId: ', lk.line_label)
    },
    isIncoming: it => it instanceof Invitation,
    attachMedia() {
      if (!this.$refs.media) return;
      if (!this.session.mediaElement) return;

      this.$refs.media.innerHTML = '';
      this.$refs.media.appendChild(this.session.mediaElement);
    },
    numberFromURI(uri) {
      return uri.toString().substring(4, 10);
    },
  },
  beforeMount(){
    this.updateDirectory();
  },
};
</script>

<style scoped>
div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 0px;
}
.groupHeader {
  background-color:#eee;
}
</style>
